import { V3Record } from "data/helpers/V3Record.js";

export const TmsKey = V3Record("tmsKey", {
  key: null,
  value: null,
  description: null,
  project: null,
  tmsJobId: null,
  tmsSetId: null,
  tmsSetValidated: false,
  matchKeyIds: [],
  createdAt: null,
  updatedAt: null,
});
